import { useEffect } from "react";
import useMediaQueries from "./useMediaQueries.js";

export const useMobileAppHeight = () => {
  const { mobileCondition } = useMediaQueries();

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    document.getElementById(
      "root"
    ).style = `height: ${window.innerHeight}px !important`;
  };

  useEffect(() => {
    if (mobileCondition) {
      appHeight();
    }
  }, [mobileCondition]);
};
